"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _pointsExchangeAllowedProviders = _interopRequireDefault(require("./points-exchange-allowed-providers.store"));
var _class;
/**
 * Promo page store
 */
let PointsExchangeEntryPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function PointsExchangeEntryPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, PointsExchangeEntryPageStore);
    this.allowedProviders = void 0;
    this.updateInitialState(initialState);
    this.allowedProviders = new _pointsExchangeAllowedProviders.default(initialState.allowedProviders);
  }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(PointsExchangeEntryPageStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }]);
  return PointsExchangeEntryPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype)), _class);
exports.default = PointsExchangeEntryPageStore;